import { DropDownTree, DropDownTreeChangeEvent, DropDownTreeExpandEvent } from "@progress/kendo-react-dropdowns";
import React from "react";
import { TicketApi } from "../../../redux/api/TicketApi";
import { expandedState, processTreeData } from "../../../utils/TreeDataOperations";
import { ITemplateListItem } from '../../../types/Ticket/ITemplate';
import { Api } from '../../../redux/api/BaseApi';
import { FilterDescriptor } from '@progress/kendo-data-query';

export const EmailTemplateList: React.FunctionComponent<TemplateListProps> = props => {
    const selectField = "selected";
    const expandField = "expanded";
    const dataItemKey = "Id";
    const subItemsField = "Templates";
    const textField = "Name";

    //const { data: template } = TicketApi.useGetTicketEmailTemplatesQuery(props.templateId, { skip: !props.templateId });
    const { data: templates, isLoading } = TicketApi.useGetTicketEmailTemplatesQuery();
    const { data: userProfile } = Api.useGetUserProfileQuery();

    //const selectedTemplate = { Id: props.templateId, Name: props.templateId ? null : null } //templates?.map(t => t.Templates.filter(t2=>t2.Id === props.templateId)
    const selectedTemplate = templates?.map(t => t.Templates.find(qn => qn.Id === props.templateId)).find(qn => qn?.Id === props.templateId);
    const [value, setValue] = React.useState(selectedTemplate);
    const [open, setOpen] = React.useState<boolean>();
    const [expanded, setExpanded] = React.useState([templates?.length ? templates?.[0][dataItemKey] : undefined]);
    const [filter, setFilter] = React.useState<FilterDescriptor>();

    const onChange = (event: DropDownTreeChangeEvent) => {
        //console.log('event', event?.value)
        if (event?.value && event?.value[subItemsField]) {
            if (!expanded.includes(event?.value.Id))
                setExpanded([event?.value.Id]); //expand
            else
                //let newArray = [...expanded].splice(expanded.indexOf(event?.value.Id)
                setExpanded((oldVal) => {
                    let newVal = [...oldVal]
                    newVal.splice(expanded.indexOf(event?.value.Id), 1)
                    return newVal;
                }); //collaps
            setOpen(true); //stay open

            //event.nativeEvent.preventDefault();
            return
        }

        if (!event.value || !props.hasDescription || window.confirm(`Changing the template will REPLACE the ${userProfile.Phrases.Action}. Are you sure you want to continue?`)) {
            setValue(event.value);
            props.onChange(event)
            setOpen(undefined); //Close
        }
    }
    const onExpandChange = React.useCallback(
        (event: DropDownTreeExpandEvent) =>
            setExpanded(expandedState(event.item, dataItemKey, expanded)),
        [expanded]
    );

    const treeData = React.useMemo(
        () => {
            const fields = { selectField, expandField, dataItemKey, subItemsField, textField };
            //console.log('processTreeData', selectedTemplate, value)
            let tree = processTreeData(templates || [], { expanded, value, filter }, fields)
            //console.log('processTreeData2', tree, expanded)
            return tree
        }, [expanded, value, templates, filter]
    );

    return (
        <div className={"k-form-field-wrap"}>
            {/* selectedTemplate:{JSON.stringify(selectedTemplate?.Id)} - props:{props.templateId} */}
            <DropDownTree size='large' data={treeData} loading={isLoading} placeholder="Select..." filterable={true} filter={filter?.value} onFilterChange={(e) => setFilter(e.filter)}
                onBlur={() => setOpen(undefined)}
                opened={open}
                value={selectedTemplate}
                dataItemKey={dataItemKey}
                textField={textField}
                subItemsField={subItemsField}
                onChange={onChange}
                selectField={selectField}
                expandField={expandField}
                onExpandChange={onExpandChange}
                popupSettings={{ height: 400 }}
            />
        </div>
    )
}

type TemplateListProps = {
    templateId?: number;
    hasDescription?: boolean;
    onChange?: (e: { value: ITemplateListItem; }) => void;
}